import Joi from "joi-browser";
import useFormState from "../../../useFormState";

export default useEvalRunConfigExpectedEventForm;
export { evalRunConfigExpectedEventSchema };

const evalRunConfigExpectedEventSchema = {
  persona: Joi.string().required().label("Persona"),
  event: Joi.string().required().label("Event"),
  expected: Joi.boolean().label("Expected"),
};

function getInitialExpectedEvent(expectedEvent) {
  return {
    persona: expectedEvent?.persona ?? "",
    event: expectedEvent?.event ?? "",
    expected: expectedEvent?.expected ?? false,
  };
}

function useEvalRunConfigExpectedEventForm(expectedEvent) {
  const { formState, validate, errors, updateFormState } = useFormState(
    () => getInitialExpectedEvent(expectedEvent),
    evalRunConfigExpectedEventSchema,
  );

  return {
    formState,
    validate,
    errors,
    updateFormState,
  };
}
